import { ExtendedContainer, ExtendedSprite, Layout } from "@aceroll/core";
import { ORIENTATIONS } from "../constants";
import { SplashPopup } from "../gameObjects";

export default class Splash extends Layout {
    init() {
        super.init();
        this.bgContainer = new ExtendedContainer('bgContainer');
        this.bgContainer.scaleMode = 'max';
        this.background = ExtendedSprite.fromAlias('img-preloader_background');
        this.background.anchor.set(0.5, 0.5);
        this.bgContainer.addChild(this.background);

        this.gameContainer = new ExtendedContainer();
        this.splashPopup = new SplashPopup(this.orientation);
        this.gameContainer.addChild(this.splashPopup);

        this.root.addChild(
            this.bgContainer,
            this.gameContainer
        );
    }

    onLandscape() {
        super.onLandscape();
        this.background.position.set(960, 540);
        this.splashPopup.position.set(960, 540);
        this.splashPopup.setLandscape();
    }

    onPortrait() {
        super.onPortrait();
        this.background.position.set(540, 960);
        this.splashPopup.position.set(540, 960);
        this.splashPopup.setPortrait();
    }

    destroy() {
        this.splashPopup.hide();
        this.root.destroy({ children: true, texture: true, baseTexture: true });
    }

    get orientation() {
        return this.isPortrait ? ORIENTATIONS.PORTRAIT : ORIENTATIONS.LANDSCAPE;
    }
}
